import React from "react";
import styled from "styled-components";
// Components
import ClientSlider from "../Elements/ClientSlider";
import ServiceBox from "../Elements/ServiceBox";

export default function Services() {
  return (
    <Wrapper id="services">
      <div className="whiteBg" style={{
        padding: "0 0 60px",
        maxWidth: 1080,
        margin: "0 auto"
      }}>
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">Servicios</h1>
          </HeaderInfo>
          <ServiceBoxRow className="flex">
            <ServiceBoxWrapper>
              <ServiceBox
                title="Digital MTK"
                subtitle="Creamos estrategias de comunicación a través de plataformas digitales  para potencializar tu marca o servicio transmitiendo mensajes específicos para tu público objetivo."
              />
            </ServiceBoxWrapper>
            <ServiceBoxWrapper>
              <ServiceBox
                title="PR & Offline MKT"
                subtitle="Elaboramos planes de comunicación para marcas esto incluye relación con medios de comunicación, comunicados de prensa, relaciones públicas, identidad e imagen de marca."
              />
            </ServiceBoxWrapper>
            <ServiceBoxWrapper>
              <ServiceBox
                title="Producción y Diseño"
                subtitle="Nos encanta crear nuevas cosas. Desarrollamos diseños inteligentes, usando el poder del branding y la tecnología."
              />
            </ServiceBoxWrapper>
          </ServiceBoxRow>
        </div>
      </div>
      <div className="lightBg" style={{ padding: "50px 0" }}>
        <div className="container">
          <HeaderInfoClients>
            <h1 className="font40 extraBold">Clientes</h1>
          </HeaderInfoClients>
          <ClientsSliderBox>
            <ClientSlider />
          </ClientsSliderBox>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
`;
const ServiceBoxRow = styled.div`
  @media (max-width: 860px) {
    flex-direction: column;
  }
`;
const ClientsSliderBox = styled.div`
  position: relative;
  width: 100%;
  @media (max-width: 860px) {
    padding-inline: 25px;
  }
`;
const ServiceBoxWrapper = styled.div`
  width: 33.333%;
  margin-right: 5%;
  padding: 20px 0;
  @media (max-width: 860px) {
    width: 100%;
    text-align: center;
    padding: 40px 0;
  }
`;
const HeaderInfoClients = styled.div`
  margin-left: 70px;
  margin-bottom: 50px;
  @media (max-width: 860px) {
    margin-left: 0;
    text-align: center;
  }
`;
const HeaderInfo = styled.div`
  @media (max-width: 860px) {
    text-align: center;
  }
`;